export const findScrollableParents = (element: Element) => {
  const scrollable = [];
  let el = element;
  while (el.parentElement) {
    if (el.parentElement.scrollHeight > el.parentElement.clientHeight) {
      scrollable.push(el.parentElement);
    }
    el = el.parentElement;
  }
  return scrollable;
};

export const copyNodeComputedStyle = (sourceNode: Element, targetNode: HTMLElement) => {
  const computedStyle = window.getComputedStyle(sourceNode);
  Array.from(computedStyle).forEach(key => targetNode.style.setProperty(
    key,
    computedStyle.getPropertyValue(key),
    computedStyle.getPropertyPriority(key)
  ));

  return targetNode;
};

export const getBoundingClientFixedPosition = (element: HTMLElement) => {
  const clientRects = element.getBoundingClientRect();

  return {
    position: 'fixed',
    top: `${clientRects.top}px`,
    left: `${clientRects.left}px`,
  };
};

export const cloneNode = <T extends HTMLElement>(node: T, deep = true) => node.cloneNode(deep) as T;
